
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9ccb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9ccb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cWZn2", function(module, exports) {
module.exports = JSON.parse("{\"id\":42,\"open\":\"2026-03-16T18:00:00+00:00\",\"close\":\"2026-03-16T18:45:00+00:00\",\"prequeue\":15,\"queue\":\"https://sff-queue.netlify.app\",\"entry\":\"https://www.shetlandfolkfestival.com/queue\",\"home\":\"https://www.shetlandfolkfestival.com/\",\"event\":\"https://www.shetlandfolkfestival.com/tickets\"}");

});

parcelRegister("7kAVY", function(module, exports) {

$parcel$export(module.exports, "base64Decode", () => $55670cfd71ce5f65$export$c62426fdd000a97e);
$parcel$export(module.exports, "base64Encode", () => $55670cfd71ce5f65$export$e510a73ee562749);
$parcel$export(module.exports, "clearStorage", () => $55670cfd71ce5f65$export$d7a0b846d036443e);
$parcel$export(module.exports, "getKey", () => $55670cfd71ce5f65$export$a47fb462a08de82f);
$parcel$export(module.exports, "eq", () => $55670cfd71ce5f65$export$9663ddc1cf085b32);
$parcel$export(module.exports, "getNow", () => $55670cfd71ce5f65$export$3991332aae1fc754);
$parcel$export(module.exports, "getOpen", () => $55670cfd71ce5f65$export$a64c4e0c0a22d56b);
$parcel$export(module.exports, "getTimestamp", () => $55670cfd71ce5f65$export$3c95c4c8b671ef0);
$parcel$export(module.exports, "gtagEvent", () => $55670cfd71ce5f65$export$53ae40010cae7216);
$parcel$export(module.exports, "isActive", () => $55670cfd71ce5f65$export$39e04e72f972b885);
/**
 * NB Event Queue | Shared functions
 *
 * @copyright 2023 NB Communication Ltd
 *
 */ 
var $cWZn2 = parcelRequire("cWZn2");
const $55670cfd71ce5f65$export$c62426fdd000a97e = (str)=>atob(str);
const $55670cfd71ce5f65$export$e510a73ee562749 = (str)=>btoa(str);
const $55670cfd71ce5f65$export$d7a0b846d036443e = (keys)=>keys.forEach((key)=>localStorage.removeItem($55670cfd71ce5f65$export$a47fb462a08de82f(key)));
const $55670cfd71ce5f65$export$9663ddc1cf085b32 = (e, q, cb)=>fetch(`${(0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).queue}/.netlify/functions/eq?e=${e}&q=${$55670cfd71ce5f65$export$e510a73ee562749(JSON.stringify(q))}`).then((response)=>response.json()).then((data)=>cb ? cb.call(null, data) : console.log(data));
const $55670cfd71ce5f65$export$a47fb462a08de82f = (key)=>`nb-event-queue${key ? `-${key}` : ''}`;
const $55670cfd71ce5f65$export$3991332aae1fc754 = ()=>{
    return +new Date();
};
const $55670cfd71ce5f65$export$a64c4e0c0a22d56b = (data)=>data.open - data.prequeue * 60000;
const $55670cfd71ce5f65$export$3c95c4c8b671ef0 = (key)=>parseInt($55670cfd71ce5f65$export$c62426fdd000a97e(localStorage.getItem($55670cfd71ce5f65$export$a47fb462a08de82f(key)) ?? $55670cfd71ce5f65$export$e510a73ee562749(0)));
const $55670cfd71ce5f65$export$53ae40010cae7216 = (params)=>'gtag' in window ? gtag('event', 'nb_event_queue', params) : null;
const $55670cfd71ce5f65$export$39e04e72f972b885 = (data, ts)=>data.open && ts > $55670cfd71ce5f65$export$a64c4e0c0a22d56b(data) && data.close && ts < data.close;

});

/**
 * NB Event Queue JS | Event
 *
 * @copyright 2023 NB Communication Ltd
 *
 */ 
var $cWZn2 = parcelRequire("cWZn2");

var $7kAVY = parcelRequire("7kAVY");
function $7f68bab488c2f114$var$nbEventQueue() {
    (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).open = +new Date((0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).open);
    (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).close = +new Date((0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).close);
    (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).ts = (0, $7kAVY.getNow)(); // Current timestamp
    // Redirect to the queue
    const redirect = (type)=>{
        // Store the entry timestamp for later use
        localStorage.setItem((0, $7kAVY.getKey)('in'), (0, $7kAVY.base64Encode)((0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).ts));
        // Log event
        (0, $7kAVY.gtagEvent)({
            redirect: type
        });
        // Redirect
        window.location.href = `${(0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).queue}?session=${(0, $7kAVY.base64Encode)(JSON.stringify((0, (/*@__PURE__*/$parcel$interopDefault($cWZn2)))))}`;
    };
    // Validate a token
    const validate = (token)=>(0, $7kAVY.eq)('validate', {
            id: (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).id,
            open: (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).open,
            close: (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).close,
            ts: (0, $7kAVY.getTimestamp)('in'),
            token: token
        }, (result)=>{
            if (result.status === 200 && result.response === true) // If valid, store
            localStorage.setItem((0, $7kAVY.getKey)('token'), token);
            else {
                // If token likely generated in the window, display an 'invalid' alert before redirecting
                if ((0, $7kAVY.getTimestamp)('in') > (0, $7kAVY.getOpen)((0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))))) {
                    (0, $7kAVY.gtagEvent)({
                        invalid: `${(0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).id},${(0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).open},${(0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).close},${(0, $7kAVY.getTimestamp)('in')},${token}`
                    });
                    alert('Sorry, your access token is invalid. Redirecting you to the queue...');
                }
                // If not valid
                // Remove any stored values
                (0, $7kAVY.clearStorage)([
                    'token',
                    'in'
                ]);
                // Redirect to the queue
                redirect(2);
            }
        });
    if (window.location.search.indexOf('reset=1') > -1) {
        (0, $7kAVY.clearStorage)([
            'token',
            'in'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).reset = 1;
    }
    if ((0, $7kAVY.isActive)((0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))), (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).ts)) {
        // If we are in the queue window
        const token = localStorage.getItem((0, $7kAVY.getKey)('token'));
        if (token) // If there is an access token stored, check it
        validate(token);
        else if (window.location.search.indexOf('token=') > -1) // If there is an access token passed, check it
        validate(window.location.search.replace(/\?token=(.*?)$/, '$1'));
        else // Redirect to the queue
        redirect(1);
    } else if (window.location.origin + window.location.pathname === (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).entry) // If queue closed, redirect to the homepage or the event if the window has passed.
    window.location.href = (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2)))[(0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).ts < (0, (/*@__PURE__*/$parcel$interopDefault($cWZn2))).open ? 'home' : 'event'];
}
document.addEventListener('DOMContentLoaded', $7f68bab488c2f114$var$nbEventQueue);


//# sourceMappingURL=_event.8bf241a6.js.map
